// extracted by mini-css-extract-plugin
module.exports = {"appWrapper":"App_appWrapper__3J9i5","appPrimaryColor":"App_appPrimaryColor__23nNV","maxWidth":"App_maxWidth__2seHK"};